// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// courses.js
export const FETCH_COURSE_SUCCESS = 'FETCH_COURSE_SUCCESS'
export const FETCH_COURSE_FAILURE = 'FETCH_COURSE_FAILURE'
export const FETCH_COURSES_SUCCESS = 'FETCH_COURSES_SUCCESS'
export const FETCH_COURSES_FAILURE = 'FETCH_COURSES_FAILURE'
export const FETCH_TERMS_SUCCESS = 'FETCH_TERMS_SUCCESS'
export const FETCH_TERMS_FAILURE = 'FETCH_TERMS_FAILURE'
export const UPDATE_TERM = 'UPDATE_TERM'
export const UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT'
export const UPDATE_SUBJECT = 'UPDATE_SUBJECT'
export const UPDATE_STATUS = 'UPDATE_STATUS'
export const UPDATE_COURSES = 'UPDATE_COURSES'


// WEBPACK FOOTER //
// /resources/js/store/mutation-types.js